document.addEventListener('DOMContentLoaded', () => {
    const multiColumCards = document.querySelectorAll('.bio-grid-component');

    multiColumCards.forEach(section => {

        section.querySelectorAll('.-bio').forEach(card => {
            card.addEventListener('click', () => {
                document.body.classList.add('scroll-fixed');

                const targetId = card.getAttribute('data-href');

                // Remove active state from all popup items
                section.querySelectorAll('.bg-popup-wrap-inner').forEach(item => {
                    item.classList.remove('is-active');
                    item.style.display = 'none';
                });

                // Show the matched popup item
                const targetItem = section.querySelector(`.bg-popup-wrap-inner[data-id="${targetId}"]`);

                if (targetItem) {
                    targetItem.classList.add('is-active');
                    targetItem.style.display = 'block';
                }

                // Open popup
                section.querySelector('.bg-popup')?.classList.add('is-active');
            });
        });

        // Close popup
        document.addEventListener('click', event => {
            if (
                event.target.closest('.bio-grid-component .bg-popup-close-btn') ||
                event.target.closest('.bio-grid-component .bg-popup-overlay')
            ) {
                document.body.classList.remove('scroll-fixed');

                const wrap = section.querySelector('.bg-popup');
                if (wrap) {
                    wrap.classList.remove('is-active');
                }
            }
        });
    });
});
